(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    // Añadir al carrito por el camino nativo de Horizon: tras el POST se emite
    // el evento estándar "shopify:cart:lines-update", que es el que hace que el
    // drawer, el contador y la lista de líneas vuelvan a pedir su sección al
    // servidor. Sin él la petición sí añadía el producto, pero el drawer seguía
    // mostrando el HTML viejo y parecía vacío.
    function qshAddToCart(variantId) {
      var routes = (window.Theme && Theme.routes) || {};
      var addUrl = routes.cart_add_url || '/cart/add.js';
      var cartUrl = (routes.cart_url || '/cart') + '.js';

      return fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('No se pudo añadir al carrito');
          return res.json();
        })
        .then(function () {
          return fetch(cartUrl)
            .then(function (r) { return r.json(); })
            .catch(function () { return null; });
        })
        .then(function (cart) {
          var evt = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
          evt.action = 'add';
          evt.promise = Promise.resolve({
            cart: cart ? { totalQuantity: cart.item_count } : undefined,
            detail: { itemCount: 1, source: 'quick-shop', didError: false }
          });
          document.dispatchEvent(evt);

          var drawer = document.getElementById('cart-drawer');
          if (drawer && typeof drawer.open === 'function') drawer.open();
        });
    }

  // El panel de tallas se monta al cargar la pagina, pero hay apartados que
  // traen tarjetas despues (recomendados, vistos recientemente): por eso el
  // montaje vive en una funcion que se puede volver a llamar. El guardia
  // qshInit evita montar dos veces la misma tarjeta.
  function initQuickShop() {
    document.querySelectorAll('.qsh-wrapper').forEach(function (wrapper) {
    if (wrapper.dataset.qshInit === 'true') return;
    wrapper.dataset.qshInit = 'true';

    var card =
      wrapper.closest('.resource-list__item') ||
      wrapper.closest('.product-grid__item') ||
      wrapper.closest('li') ||
      wrapper.closest('.card-gallery');
    var img = card ? card.querySelector('.card-gallery img') : null;
    var swatchContainer = card ? card.querySelector('.qsh-swatches') : null;
    var addBtn = wrapper.querySelector('.qsh-add-btn');
    var variantsDataEl = wrapper.querySelector('.qsh-variants-data');
    var colorPos = wrapper.getAttribute('data-color-position');
    var sizePos = wrapper.getAttribute('data-size-position');
    var variants = [];

    try {
      variants = variantsDataEl ? JSON.parse(variantsDataEl.textContent) : [];
    } catch (e) {
      variants = [];
    }

    var selectedColor = null;
    var selectedSize = null;
    var selectedVariantId = null;

    function optionValue(variant, position) {
      if (position == 1) return variant.option1;
      if (position == 2) return variant.option2;
      if (position == 3) return variant.option3;
      return null;
    }

    function updateAddState() {
      selectedVariantId = null;

      if (selectedColor && selectedSize) {
        var match = variants.find(function (v) {
          return (
            optionValue(v, colorPos) === selectedColor &&
            optionValue(v, sizePos) === selectedSize
          );
        });
        if (match && match.available) {
          selectedVariantId = match.id;
        }
      } else if (!colorPos || colorPos == '0') {
        // Producto sin opción de color: solo se necesita la talla
        if (selectedSize) {
          var matchNoColor = variants.find(function (v) {
            return optionValue(v, sizePos) === selectedSize;
          });
          if (matchNoColor && matchNoColor.available) {
            selectedVariantId = matchNoColor.id;
          }
        }
      }

      if (addBtn) {
        addBtn.disabled = !selectedVariantId;
      }
    }

    if (swatchContainer) {
      swatchContainer.querySelectorAll('.qsh-swatch').forEach(function (sw) {
        sw.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          wrapper.classList.add('is-open');
          swatchContainer.querySelectorAll('.qsh-swatch').forEach(function (s) {
            s.classList.remove('is-active');
          });
          sw.classList.add('is-active');
          selectedColor = sw.getAttribute('data-color');
          var newSrc = sw.getAttribute('data-image');
          if (newSrc && img) img.src = newSrc;
          updateAddState();
        });
      });
    }

    wrapper.querySelectorAll('.qsh-size-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        // Elegir talla no debe entrar al producto ni cerrar el panel: se marca
        // abierto a propósito para que se quede donde está.
        e.preventDefault();
        e.stopPropagation();
        wrapper.classList.add('is-open');
        wrapper.querySelectorAll('.qsh-size-btn').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');
        selectedSize = btn.getAttribute('data-size');
        updateAddState();
      });
    });

    // La tira de tallas se arrastra con el dedo o con el mouse. Con captura de
    // puntero el arrastre continúa aunque el cursor se salga de la tarjeta, y
    // la clase is-dragging-open evita que el panel se cierre en pleno gesto.
    var sizeList = wrapper.querySelector('.qsh-size-list');
    var sizeInner = wrapper.querySelector('.qsh-size-popup-inner');
    if (sizeList) {
      var dragging = false;
      var startX = 0;
      var startScroll = 0;
      var moved = 0;

      function updateOverflow() {
        var max = sizeList.scrollWidth - sizeList.clientWidth;
        var overflow = max > 2;
        sizeList.classList.toggle('has-overflow', overflow);
        sizeList.classList.toggle('at-start', sizeList.scrollLeft <= 1);
        sizeList.classList.toggle('at-end', sizeList.scrollLeft >= max - 1);
        if (sizeInner) {
          sizeInner.classList.toggle('has-overflow', overflow);
          sizeInner.classList.toggle('at-end', sizeList.scrollLeft >= max - 1);
        }
      }

      function endDrag(e) {
        if (!dragging) return;
        dragging = false;
        if (e && e.pointerId != null && sizeList.releasePointerCapture && sizeList.hasPointerCapture(e.pointerId)) {
          try { sizeList.releasePointerCapture(e.pointerId); } catch (err) {}
        }
        wrapper.classList.remove('is-dragging-open');
        setTimeout(function () {
          sizeList.classList.remove('is-dragging');
        }, 0);
      }

      sizeList.addEventListener('pointerdown', function (e) {
        dragging = true;
        moved = 0;
        startX = e.clientX;
        startScroll = sizeList.scrollLeft;
      });

      sizeList.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 3) {
          moved = Math.abs(dx);
          sizeList.classList.add('is-dragging');
          wrapper.classList.add('is-dragging-open');
          if (e.pointerType === 'mouse') {
            e.preventDefault();
            // La captura se pide aquí, no en pointerdown: si se pide antes, el
            // navegador redirige el click al contenedor y los botones dejan de
            // poder pulsarse.
            if (sizeList.setPointerCapture && !sizeList.hasPointerCapture(e.pointerId)) {
              try { sizeList.setPointerCapture(e.pointerId); } catch (err) {}
            }
            sizeList.scrollLeft = startScroll - dx;
          }
        }
      });

      ['pointerup', 'pointercancel'].forEach(function (evt) {
        sizeList.addEventListener(evt, endDrag);
      });
      window.addEventListener('pointerup', endDrag);

      sizeList.addEventListener('scroll', updateOverflow, { passive: true });
      unfOnResize(updateOverflow);
      if (window.ResizeObserver) {
        new ResizeObserver(updateOverflow).observe(sizeList);
      }
      updateOverflow();

      sizeList.addEventListener('click', function (e) {
        if (moved > 5) {
          e.preventDefault();
          e.stopPropagation();
          moved = 0;
        }
      }, true);

      sizeList.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });
    }

    // Botón + de móvil: abre y cierra el panel de tallas. La tarjeta suele estar
    // dentro de un enlace, por eso frenamos la propagación del tap.
    var mobileToggle = wrapper.querySelector('.qsh-mobile-toggle');
    if (mobileToggle) {
      mobileToggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var willOpen = !wrapper.classList.contains('is-open');
        document.querySelectorAll('.qsh-wrapper.is-open').forEach(function (other) {
          if (other !== wrapper) other.classList.remove('is-open');
        });
        wrapper.classList.toggle('is-open', willOpen);
        mobileToggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    }

    // Dentro del panel abierto, ningún tap debe navegar al producto.
    var popupEl = wrapper.querySelector('.qsh-size-popup');
    if (popupEl) {
      popupEl.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }

    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (!selectedVariantId || addBtn.disabled) return;

        addBtn.disabled = true;

        qshAddToCart(selectedVariantId)
          .then(function () {
            addBtn.classList.add('is-added');

            setTimeout(function () {
              addBtn.classList.remove('is-added');
              updateAddState();
            }, 1500);
          })
          .catch(function () {
            updateAddState();
          });
      });
    }
    });
  }

  initQuickShop();
  document.addEventListener('shopify:section:load', initQuickShop);
  // Lo emiten las secciones que inyectan tarjetas por AJAX.
  document.addEventListener('unf:cards-added', initQuickShop);

  // ══════════════════════════════════════════════════════════════
  // CÓMO SE CIERRA EL PANEL DE TALLAS AL TOCAR FUERA (móvil).
  //
  // Antes: un simple listener que quitaba la clase. El problema es que
  // NO frenaba el tap. O sea que el mismo toque que cerraba el panel
  // seguía su camino y activaba lo que hubiera debajo — normalmente el
  // enlace de otra tarjeta. Por eso, yendo rápido, se acababa entrando
  // a un producto que no se quería abrir.
  //
  // Ahora, en celular, mientras hay un panel abierto el PRIMER toque
  // fuera solo cierra: se traga y no activa nada. El segundo toque ya
  // funciona normal. Es el mismo patrón de cualquier menú desplegable.
  //
  // Y la zona del precio es un caso aparte. Ahí viven los círculos de
  // color, que en celular son diminutos: fallar el dedo y darle al
  // precio es constante. Si eso cerrara el panel, habría que volver a
  // abrirlo cada vez. Así que en esa zona hacen falta TRES toques
  // seguidos para cerrar. Acertarle a un círculo de color reinicia la
  // cuenta, y dejar pasar más de un segundo y medio también.
  // ══════════════════════════════════════════════════════════════
  if (!document.body.dataset.qshOutsideClickInit) {
    document.body.dataset.qshOutsideClickInit = 'true';

    var QSH_PRICE_TAPS_TO_CLOSE = 3;
    var QSH_PRICE_TAP_WINDOW = 1500;
    var qshPriceTaps = 0;
    var qshPriceTapAt = 0;

    function qshIsMobile() {
      return window.matchMedia('(max-width: 749px)').matches || window.matchMedia('(hover: none)').matches;
    }

    function qshCloseWrapper(w) {
      w.classList.remove('is-open');
      var t = w.querySelector('.qsh-mobile-toggle');
      if (t) t.setAttribute('aria-expanded', 'false');
    }

    function qshCardOf(wrapper) {
      return (
        wrapper.closest('.resource-list__item') ||
        wrapper.closest('.product-grid__item') ||
        wrapper.closest('li') ||
        wrapper.closest('.card-gallery') ||
        wrapper
      );
    }

    // La zona del precio: el bloque <product-price>, que en las tarjetas
    // lleva el precio Y los círculos de color debajo.
    function qshPriceZoneOf(card) {
      return card ? card.querySelector('product-price, .qsh-swatches') : null;
    }

    // Capture: hay que decidir ANTES que nadie, porque si el evento
    // llega al enlace de la tarjeta ya es tarde para frenarlo.
    document.addEventListener(
      'click',
      function (e) {
        var open = document.querySelector('.qsh-wrapper.is-open');
        if (!open) {
          qshPriceTaps = 0;
          return;
        }

        // El propio panel de tallas y el botón + siguen funcionando como
        // siempre. Todo lo demás —incluida la foto de esta misma
        // tarjeta— cuenta como "fuera": el primer toque solo cierra.
        if (open.contains(e.target)) return;

        var card = qshCardOf(open);

        // En escritorio no se cambia nada: tocar fuera cierra, sin más.
        if (!qshIsMobile()) {
          if (!card.contains(e.target)) qshCloseWrapper(open);
          return;
        }

        var priceZone = qshPriceZoneOf(card);
        var inPriceZone = priceZone && priceZone.contains(e.target);

        if (inPriceZone) {
          // Acertarle a un círculo de color es un acierto, no un intento
          // de salir: se reinicia la cuenta y su propio manejador hace
          // el resto (cambia la foto y deja el panel abierto).
          if (e.target.closest('.qsh-swatch')) {
            qshPriceTaps = 0;
            return;
          }

          // Fallo del dedo sobre el precio. Nunca navega, y solo cierra
          // al tercer intento seguido.
          e.preventDefault();
          e.stopPropagation();

          var now = Date.now();
          qshPriceTaps = now - qshPriceTapAt > QSH_PRICE_TAP_WINDOW ? 1 : qshPriceTaps + 1;
          qshPriceTapAt = now;

          if (qshPriceTaps >= QSH_PRICE_TAPS_TO_CLOSE) {
            qshPriceTaps = 0;
            qshCloseWrapper(open);
          }
          return;
        }

        // Cualquier otro punto de la pantalla: este toque solo cierra.
        // Se traga para que no abra el producto de al lado.
        qshPriceTaps = 0;
        e.preventDefault();
        e.stopPropagation();
        document.querySelectorAll('.qsh-wrapper.is-open').forEach(qshCloseWrapper);
      },
      true
    );
  }
})();

  (function () {
    // Flechas propias de la tarjeta. En vez de pedirle el cambio al componente
    // del tema (que encadena esperas), se mueve la tira de fotos a mano con un
    // desplazamiento propio: se ve como si arrastraras de lado, y como cada
    // pulsacion vuelve a apuntar desde donde va, se puede pulsar sin parar.
    function initCardArrows(nav) {
      if (nav.dataset.cgaInit === 'true') return;
      nav.dataset.cgaInit = 'true';

      var gallery = nav.closest('.card-gallery');
      var scroller = gallery && gallery.querySelector('slideshow-slides');
      if (!scroller) return;

      var scope = nav.closest('.cga');
      var instant = scope && scope.classList.contains('cga--speed-instant');
      var speed = parseInt(scope && scope.getAttribute('data-cga-speed'), 10);
      if (isNaN(speed)) speed = 220;

      function slides() {
        return Array.prototype.slice.call(gallery.querySelectorAll('slideshow-slide:not([hidden])'));
      }

      // Con una sola foto las flechas no pintan nada.
      function refresh() {
        nav.hidden = slides().length < 2;
      }

      function positions() {
        var arr = slides();
        if (!arr.length) return [];
        var base = arr[0].offsetLeft;
        return arr.map(function (el) {
          return el.offsetLeft - base;
        });
      }

      function gapSize() {
        return parseFloat(getComputedStyle(scroller).columnGap) || 0;
      }

      // Ancho de una foto mas su separacion: la unidad de un paso.
      function stepWidth() {
        var arr = slides();
        if (!arr.length) return 0;
        return arr[0].getBoundingClientRect().width + gapSize();
      }

      // ---------- Movimiento ----------
      // Un solo desplazamiento continuo que persigue un destino. Cada pulsacion
      // adelanta el destino una foto mas; como el movimiento va siempre a por
      // el destino y la velocidad depende de lo lejos que este, pulsar seguido
      // lo acelera solo, y en cuanto dejas de pulsar frena y se planta en la
      // foto que toca. No hay cola ni pasos pendientes que sigan corriendo.
      var raf = null;
      var target = null;
      var lastFrame = 0;

      function stop() {
        if (raf) cancelAnimationFrame(raf);
        raf = null;
        target = null;
      }

      function startLoop() {
        lastFrame = performance.now();

        function frame(now) {
          if (target === null) {
            raf = null;
            return;
          }

          // dt real para que la velocidad sea la misma en cualquier pantalla.
          var dt = Math.min(64, now - lastFrame);
          lastFrame = now;

          var cur = scroller.scrollLeft;
          var dist = target - cur;

          // Menos de medio pixel: se acomoda y termina.
          if (Math.abs(dist) < 0.5) {
            scroller.scrollLeft = target;
            stop();
            return;
          }

          // Cuanto mas lejos quedo el destino (mas toques seguidos), mas corto
          // el tiempo de reaccion: de ahi la aceleracion.
          var one = stepWidth() || 1;
          var steps = Math.abs(dist) / one;
          var tau = (speed / 3) / Math.min(3, Math.max(1, steps));
          if (tau < 40) tau = 40;

          scroller.scrollLeft = cur + dist * (1 - Math.exp(-dt / tau));
          raf = requestAnimationFrame(frame);
        }

        raf = requestAnimationFrame(frame);
      }

      function slideTo(x) {
        if (instant || speed <= 0) {
          scroller.scrollLeft = x;
          return;
        }

        target = x;
        if (!raf) startLoop();
      }

      // ---------- Secuencia circular ----------
      // En vez de rebobinar hasta el principio al llegar al final, se mueve la
      // foto del extremo contrario al otro lado y se corrige el desplazamiento
      // en el mismo instante. Visualmente nada salta: la tira sigue avanzando
      // siempre en la misma direccion, como un circulo.
      function rotate(dir) {
        var arr = slides();
        if (arr.length < 2) return;

        var delta = 0;

        if (dir > 0) {
          var first = arr[0];
          delta = -(first.getBoundingClientRect().width + gapSize());
          scroller.appendChild(first);
        } else {
          var last = arr[arr.length - 1];
          delta = last.getBoundingClientRect().width + gapSize();
          scroller.insertBefore(last, arr[0]);
        }

        scroller.scrollLeft = scroller.scrollLeft + delta;
        // El destino vive en las mismas coordenadas: se corrige igual para que
        // el movimiento en curso no se rompa al rotar.
        if (target !== null) target += delta;
      }

      function move(dir, e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }

        var pos = positions();
        if (pos.length < 2) return;

        // Se parte del destino pendiente: cada toque suma una foto mas por
        // delante y el movimiento se acelera para alcanzarlo.
        var from = target === null ? scroller.scrollLeft : target;
        var index = 0;
        var best = Infinity;
        pos.forEach(function (x, i) {
          var d = Math.abs(x - from);
          if (d < best) {
            best = d;
            index = i;
          }
        });

        // Si toca salirse por un extremo, primero se rota la tira para que la
        // siguiente foto quede justo al lado y el avance continue seguido.
        if (dir > 0 && index === pos.length - 1) {
          rotate(1);
          pos = positions();
          index = pos.length - 2;
        } else if (dir < 0 && index === 0) {
          rotate(-1);
          pos = positions();
          index = 1;
        }

        var to = index + dir;
        if (to < 0 || to > pos.length - 1) return;

        slideTo(pos[to]);
      }

      var prev = nav.querySelector('[data-cga-prev]');
      var next = nav.querySelector('[data-cga-next]');
      if (prev) prev.addEventListener('click', function (e) { move(-1, e); });
      if (next) next.addEventListener('click', function (e) { move(1, e); });

      // Si el dedo toca la tira, manda el dedo: se corta el movimiento y se
      // descarta lo que quedara en cola.
      scroller.addEventListener(
        'pointerdown',
        function () {
          stop();
        },
        { passive: true }
      );

      // ---------- Ciclo circular con el dedo ----------
      // Al deslizar en el celular la tira se queda quieta al llegar al extremo.
      // Cuando el dedo suelta y la foto ya se acomodo en el borde, se rota la
      // tira hacia donde iba el gesto: aparece foto nueva del lado correcto y
      // se puede seguir deslizando sin fin. La rotacion solo se hace en el
      // sentido del gesto, asi no se queda dando vueltas sola.
      var lastLeft = scroller.scrollLeft;
      var swipeDir = 0;
      var settleTimer = null;
      var lockUntil = 0;
      var touching = false;

      function settle() {
        if (touching || raf) return;
        if (performance.now() < lockUntil) return;
        if (!swipeDir) return;

        var pos = positions();
        if (pos.length < 2) return;

        var here = scroller.scrollLeft;
        var index = 0;
        var best = Infinity;
        pos.forEach(function (x, i) {
          var d = Math.abs(x - here);
          if (d < best) {
            best = d;
            index = i;
          }
        });

        if (swipeDir > 0 && index === pos.length - 1) {
          rotate(1);
          lockUntil = performance.now() + 350;
        } else if (swipeDir < 0 && index === 0) {
          rotate(-1);
          lockUntil = performance.now() + 350;
        }

        swipeDir = 0;
      }

      scroller.addEventListener(
        'scroll',
        function () {
          var now = scroller.scrollLeft;
          if (Math.abs(now - lastLeft) > 1) swipeDir = now > lastLeft ? 1 : -1;
          lastLeft = now;
          if (settleTimer) clearTimeout(settleTimer);
          settleTimer = setTimeout(settle, 140);
        },
        { passive: true }
      );

      scroller.addEventListener(
        'pointerdown',
        function () {
          touching = true;
        },
        { passive: true }
      );

      window.addEventListener(
        'pointerup',
        function () {
          if (!touching) return;
          touching = false;
          if (settleTimer) clearTimeout(settleTimer);
          settleTimer = setTimeout(settle, 160);
        },
        { passive: true }
      );

      // El tema deja arrastrar la tira con el mouse. En PC se corta antes de
      // llegar a su componente: el movimiento solo lo mandan las flechas. El
      // clic sobre la foto sigue abriendo el producto.
      gallery.addEventListener(
        'mousedown',
        function (e) {
          if (!window.matchMedia('(min-width: 750px)').matches) return;
          if (e.target.closest && e.target.closest('.cga-nav')) return;
          e.stopPropagation();
        },
        true
      );

      refresh();
      // Al cambiar de color cambian las fotos visibles.
      gallery.addEventListener('slideshowSelect', refresh);
      window.addEventListener('load', refresh);
    }

    function run() {
      document.querySelectorAll('[data-cga]').forEach(initCardArrows);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }

    document.addEventListener('shopify:section:load', run);
    document.addEventListener('unf:cards-added', run);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
  // Nombre del evento nativo de Horizon que se dispara cada vez que se elige
  // una variante distinta (color, talla...). Va con el nombre tal cual en vez
  // de importarlo, porque el resto del bloque tampoco usa "import".
  var PRODUCT_SELECT_EVENT = 'shopify:product:select';

  // Arma toda la galería (miniaturas, foto grande, arrastre, sincronía
  // móvil/escritorio) para un nodo [data-gt] concreto. Se llama una vez al
  // cargar la página y se vuelve a llamar cada vez que se reemplaza la
  // galería por la versión ya filtrada que llega del servidor al cambiar de
  // variante.
  function initGallery(gallery) {
    gallery.dataset.gtInit = 'true';

    var thumbsWrap = gallery.querySelector('[data-gt-thumbs]');
    var mainWrap = gallery.querySelector('[data-gt-main]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gt-thumb]'));
    var medias = Array.prototype.slice.call(gallery.querySelectorAll('[data-gt-media]'));
    var limit = parseInt(gallery.dataset.maxThumbs, 10) || 14;
    var scrollOffset = parseInt(gallery.dataset.scrollOffset, 10) || 0;
    var swipe = gallery.classList.contains('gt--swipe');

    function isDesktop() {
      return window.matchMedia('(min-width: 750px)').matches;
    }

    function markActive(index) {
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', parseInt(t.dataset.index, 10) === index);
      });
      medias.forEach(function (m) {
        m.classList.toggle('is-active', parseInt(m.dataset.index, 10) === index);
      });
    }

    // Móvil con deslizamiento: lleva el carrusel hasta la foto pedida.
    // offsetLeft en vez de índice por ancho, así el espacio entre fotos no
    // descuadra el salto.
    function slideTo(index, smooth) {
      if (!mainWrap || !medias[index]) return;
      var left = medias[index].offsetLeft - medias[0].offsetLeft;
      if (mainWrap.scrollTo) {
        mainWrap.scrollTo({ left: left, behavior: smooth === false ? 'auto' : 'smooth' });
      } else {
        mainWrap.scrollLeft = left;
      }
    }

    // Mantiene visible la miniatura de la foto que se está viendo.
    function revealThumb(index) {
      if (!thumbsWrap || !thumbs[index] || isDesktop()) return;
      var t = thumbs[index];
      var target = t.offsetLeft - thumbsWrap.clientWidth / 2 + t.offsetWidth / 2;
      var max = thumbsWrap.scrollWidth - thumbsWrap.clientWidth;
      target = Math.max(0, Math.min(target, max));
      if (thumbsWrap.scrollTo) {
        thumbsWrap.scrollTo({ left: target, behavior: 'smooth' });
      } else {
        thumbsWrap.scrollLeft = target;
      }
    }

    // Alto de la columna: justo el de "miniaturas visibles a la vez", sin pasar
    // de lo que queda de pantalla. A partir de ahí la columna se desplaza.
    function sizeThumbs() {
      if (!thumbsWrap) return;
      if (!isDesktop()) {
        thumbsWrap.style.maxHeight = '';
        return;
      }
      // Al pasar a escritorio las fotos vuelven a estar apiladas: el carrusel
      // se deja al principio para que no quede a medio camino.
      if (mainWrap && swipe && mainWrap.scrollLeft !== 0) mainWrap.scrollLeft = 0;
      if (thumbs.length <= limit) {
        thumbsWrap.style.maxHeight = '';
        return;
      }
      var gap = parseFloat(getComputedStyle(thumbsWrap).rowGap) || 0;
      var itemH = thumbs[0].getBoundingClientRect().height;
      var pad = parseFloat(getComputedStyle(thumbsWrap).paddingTop) || 0;
      var wanted = itemH * limit + gap * (limit - 1) + pad * 2;
      var available = window.innerHeight - (parseFloat(getComputedStyle(gallery).getPropertyValue('--gt-sticky-top')) || 24) - 24;
      thumbsWrap.style.maxHeight = Math.max(120, Math.min(wanted, available)) + 'px';
    }

    // Escritorio: la miniatura no cambia la foto, lleva hasta ella.
    // Móvil: la miniatura sí cambia la foto grande.
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function (e) {
        e.preventDefault();
        var index = parseInt(thumb.dataset.index, 10);
        var target = medias[index];
        if (!target) return;

        if (isDesktop()) {
          // scrollIntoView funciona sea la ventana o un contenedor con scroll
          // quien esté desplazándose; el margen superior lo pone el CSS con
          // scroll-margin-top, así no hay que calcular posiciones a mano.
          if (target.scrollIntoView) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } else {
            window.scrollTo(0, target.getBoundingClientRect().top + window.pageYOffset - scrollOffset);
          }
        } else if (swipe) {
          slideTo(index);
        }
        markActive(index);
      });
    });

    // Móvil: al arrastrar la foto grande, la miniatura marcada sigue a la foto
    // que queda en pantalla. Se calcula al terminar el desplazamiento.
    if (mainWrap && swipe) {
      var scrollTimer = null;
      mainWrap.addEventListener(
        'scroll',
        function () {
          if (isDesktop()) return;
          if (scrollTimer) clearTimeout(scrollTimer);
          scrollTimer = setTimeout(function () {
            var center = mainWrap.scrollLeft + mainWrap.clientWidth / 2;
            var base = medias[0].offsetLeft;
            var closest = 0;
            var best = Infinity;
            medias.forEach(function (m, i) {
              var mid = m.offsetLeft - base + m.offsetWidth / 2;
              var dist = Math.abs(mid - center);
              if (dist < best) {
                best = dist;
                closest = i;
              }
            });
            markActive(closest);
            revealThumb(closest);
          }, 90);
        },
        { passive: true }
      );
    }

    // En escritorio la miniatura marcada es la de la foto que se está viendo.
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          if (!isDesktop()) return;
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              markActive(parseInt(entry.target.dataset.index, 10));
            }
          });
        },
        { rootMargin: '-45% 0px -45% 0px', threshold: 0 }
      );
      medias.forEach(function (m) {
        observer.observe(m);
      });
    }

    // Arrastre de la columna: horizontal en móvil, vertical en escritorio.
    if (thumbsWrap) {
      var dragging = false;
      var startX = 0;
      var startY = 0;
      var startScrollLeft = 0;
      var startScrollTop = 0;
      var moved = 0;

      thumbsWrap.addEventListener('pointerdown', function (e) {
        dragging = true;
        moved = 0;
        startX = e.clientX;
        startY = e.clientY;
        startScrollLeft = thumbsWrap.scrollLeft;
        startScrollTop = thumbsWrap.scrollTop;
      });

      thumbsWrap.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var vertical = isDesktop();
        var delta = vertical ? e.clientY - startY : e.clientX - startX;
        if (Math.abs(delta) > 6) {
          moved = Math.abs(delta);
          thumbsWrap.classList.add('is-dragging');
          if (e.pointerType === 'mouse') {
            e.preventDefault();
            // La captura se pide aquí, no en pointerdown: si se pide antes, el
            // navegador redirige el click al contenedor y los botones dejan de
            // poder pulsarse.
            if (thumbsWrap.setPointerCapture && !thumbsWrap.hasPointerCapture(e.pointerId)) {
              try { thumbsWrap.setPointerCapture(e.pointerId); } catch (err) {}
            }
            if (vertical) {
              thumbsWrap.scrollTop = startScrollTop - delta;
            } else {
              thumbsWrap.scrollLeft = startScrollLeft - delta;
            }
          }
        }
      });

      ['pointerup', 'pointercancel'].forEach(function (evt) {
        thumbsWrap.addEventListener(evt, function (e) {
          dragging = false;
          if (thumbsWrap.releasePointerCapture) {
            try { thumbsWrap.releasePointerCapture(e.pointerId); } catch (err) {}
          }
          setTimeout(function () {
            thumbsWrap.classList.remove('is-dragging');
          }, 0);
        });
      });

      thumbsWrap.addEventListener('click', function (e) {
        // Umbral algo holgado: en el celular un toque siempre trae unos
        // píxeles de movimiento, y con el umbral muy bajo el toque se anulaba
        // y la miniatura no cambiaba la foto.
        if (moved > 8) {
          e.preventDefault();
          e.stopPropagation();
          moved = 0;
        }
      }, true);

      thumbsWrap.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });
    }

    unfOnResize(sizeThumbs);
    window.addEventListener('load', sizeThumbs);
    sizeThumbs();
  }

  // Reemplaza la galería vieja por la nueva con un fundido corto en vez de un
  // cambio seco: primero achica/desvanece la vieja, la cambia por la nueva ya
  // en ese mismo estado invisible, y en el siguiente frame le quita la clase
  // para que la transición de CSS la haga aparecer. Si el visitante tiene
  // activado "reducir movimiento", se salta la animación y cambia directo.
  function swapGalleryWithTransition(currentGallery, newGallery) {
    var reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function doSwap() {
      currentGallery.replaceWith(newGallery);
      initGallery(newGallery);
    }

    if (reduceMotion) {
      doSwap();
      return;
    }

    currentGallery.classList.add('gt--swap-out');

    window.setTimeout(function () {
      newGallery.classList.add('gt--swap-in');
      doSwap();

      // Fuerza al navegador a registrar el estado "invisible/achicada" antes
      // de quitarle la clase; si no, entra y sale en el mismo frame y no se
      // ve ninguna transición.
      void newGallery.offsetWidth;
      newGallery.classList.remove('gt--swap-in');
    }, 220);
  }

  // Cuando cambia la variante (color, talla...), Horizon vuelve a pedir la
  // página con esa variante ya seleccionada y avisa con este evento, pasando
  // el HTML nuevo ya renderizado en "event.promise". Ahí adentro está esta
  // misma galería, pero con las fotos ya filtradas según la variante elegida:
  // solo hay que buscarla, poner ese trozo de HTML en el sitio del viejo y
  // volver a inicializarla. Un solo listener por sección alcanza: cada vez que
  // se dispara vuelve a buscar la galería "viva" en ese momento, así que no
  // importa que el nodo original ya se haya reemplazado antes.
  function bindVariantSync(gallery) {
    var section = gallery.closest('.shopify-section, dialog');
    if (!section || section.dataset.gtVariantSyncBound === 'true') return;
    section.dataset.gtVariantSyncBound = 'true';

    var blockId = gallery.dataset.gtBlockId;
    var selector = blockId ? '[data-gt][data-gt-block-id="' + blockId + '"]' : '[data-gt]';
    var colorOptionName = (gallery.dataset.gtColorOption || 'color').trim().toLowerCase();

    // Averigua qué opción (Color, Talla...) fue la que se acaba de tocar,
    // buscando el input/select que disparó el cambio a partir del id que
    // trae el propio evento. Si no se puede saber, se deja pasar (mejor
    // actualizar de más que quedarse con fotos desactualizadas).
    function isColorOptionChange(event) {
      var optionValueId = event.detail && event.detail.optionValueId;
      if (!optionValueId || !(event.target instanceof Element)) return true;

      var changedInput = event.target.querySelector('[data-option-value-id="' + optionValueId + '"]');
      var changedOptionName = changedInput && changedInput.dataset && changedInput.dataset.optionName;
      if (!changedOptionName) return true;

      return changedOptionName.trim().toLowerCase() === colorOptionName;
    }

    section.addEventListener(PRODUCT_SELECT_EVENT, function (event) {
      // Las miniaturas/swatches de las tarjetas de producto (listados,
      // recomendados) también disparan este evento; no son esta galería.
      if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
      // Solo nos interesa cuando cambia el color: si cambió la talla u otra
      // opción, las fotos no dependen de eso y no hay que tocar la galería.
      if (!isColorOptionChange(event)) return;
      if (!event.promise || typeof event.promise.then !== 'function') return;

      event.promise
        .then(function (result) {
          var detail = result && result.detail;
          if (!detail || !detail.html) return;

          var newGallery = detail.html.querySelector(selector);
          var currentGallery = section.querySelector(selector);
          if (!newGallery || !currentGallery) return;

          swapGalleryWithTransition(currentGallery, newGallery);
        })
        .catch(function (error) {
          if (error && error.name !== 'AbortError') {
            console.warn('[product-media-gallery] Event promise rejected:', error);
          }
        });
    });
  }

  document.querySelectorAll('[data-gt]').forEach(function (gallery) {
    if (gallery.dataset.gtInit !== 'true') initGallery(gallery);
    bindVariantSync(gallery);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["complete-the-look"] && !Shopify.designMode) return;
  try {
    (function () {
    // Añadir al carrito por el camino nativo de Horizon: tras el POST se emite
    // el evento estándar "shopify:cart:lines-update", que es el que hace que el
    // drawer, el contador y la lista de líneas vuelvan a pedir su sección al
    // servidor. Sin él la petición sí añadía el producto, pero el drawer seguía
    // mostrando el HTML viejo y parecía vacío.
    function ctlAddToCart(variantId) {
      var routes = (window.Theme && Theme.routes) || {};
      var addUrl = routes.cart_add_url || '/cart/add.js';
      var cartUrl = (routes.cart_url || '/cart') + '.js';

      return fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('No se pudo añadir al carrito');
          return res.json();
        })
        .then(function () {
          return fetch(cartUrl)
            .then(function (r) { return r.json(); })
            .catch(function () { return null; });
        })
        .then(function (cart) {
          var evt = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
          evt.action = 'add';
          evt.promise = Promise.resolve({
            cart: cart ? { totalQuantity: cart.item_count } : undefined,
            detail: { itemCount: 1, source: 'quick-shop', didError: false }
          });
          document.dispatchEvent(evt);

          var drawer = document.getElementById('cart-drawer');
          if (drawer && typeof drawer.open === 'function') drawer.open();
        });
    }

  document.querySelectorAll('.ctl-card').forEach(function (card) {
    if (card.dataset.ctlInit === 'true') return;
    card.dataset.ctlInit = 'true';

    var img = card.querySelector('.ctl-image');
    var addBtn = card.querySelector('.ctl-add-btn');
    var variantsDataEl = card.querySelector('.ctl-variants-data');
    var colorPos = card.getAttribute('data-color-position');
    var sizePos = card.getAttribute('data-size-position');
    var variants = [];

    try {
      variants = variantsDataEl ? JSON.parse(variantsDataEl.textContent) : [];
    } catch (e) {
      variants = [];
    }

    var selectedColor = null;
    var selectedSize = null;
    var selectedVariantId = null;

    function optionValue(variant, position) {
      if (position == 1) return variant.option1;
      if (position == 2) return variant.option2;
      if (position == 3) return variant.option3;
      return null;
    }

    function updateAddState() {
      selectedVariantId = null;

      if (selectedColor && selectedSize) {
        var match = variants.find(function (v) {
          return (
            optionValue(v, colorPos) === selectedColor &&
            optionValue(v, sizePos) === selectedSize
          );
        });
        if (match && match.available) {
          selectedVariantId = match.id;
        }
      }

      if (addBtn) {
        addBtn.disabled = !selectedVariantId;
      }
    }

    card.querySelectorAll('.ctl-swatch').forEach(function (sw) {
      sw.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        card.classList.add('is-popup-open');
        card.querySelectorAll('.ctl-swatch').forEach(function (s) {
          s.classList.remove('is-active');
        });
        sw.classList.add('is-active');
        selectedColor = sw.getAttribute('data-color');
        var newSrc = sw.getAttribute('data-image');
        if (newSrc && img) img.src = newSrc;
        updateAddState();
      });
    });

    card.querySelectorAll('.ctl-size-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        // Elegir talla no cierra el panel ni entra al producto.
        e.preventDefault();
        e.stopPropagation();
        card.classList.add('is-popup-open');
        card.querySelectorAll('.ctl-size-btn').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');
        selectedSize = btn.getAttribute('data-size');
        updateAddState();
      });
    });

    // Táctil: en dispositivos sin hover, un tap dentro de .ctl-info (fuera del
    // link del nombre y del propio panel) revela el panel de tallas glass,
    // igual que el hover en escritorio. El link del título sigue navegando
    // normalmente.
    var infoEl = card.querySelector('.ctl-info');
    var sizePopupEl = card.querySelector('.ctl-size-popup');
    var mobileToggle = card.querySelector('.ctl-mobile-toggle');

    // La tira de tallas se arrastra con el dedo o con el mouse. Con captura de
    // puntero el arrastre continúa aunque el cursor se salga de la tarjeta, y
    // la clase is-dragging-open evita que el panel se cierre en pleno gesto.
    var sizeList = card.querySelector('.ctl-size-list');
    var sizeInner = card.querySelector('.ctl-size-popup-inner');
    if (sizeList) {
      var dragging = false;
      var startX = 0;
      var startScroll = 0;
      var moved = 0;

      function updateOverflow() {
        var max = sizeList.scrollWidth - sizeList.clientWidth;
        var overflow = max > 2;
        sizeList.classList.toggle('has-overflow', overflow);
        sizeList.classList.toggle('at-start', sizeList.scrollLeft <= 1);
        sizeList.classList.toggle('at-end', sizeList.scrollLeft >= max - 1);
        if (sizeInner) {
          sizeInner.classList.toggle('has-overflow', overflow);
          sizeInner.classList.toggle('at-end', sizeList.scrollLeft >= max - 1);
        }
      }

      function endDrag(e) {
        if (!dragging) return;
        dragging = false;
        if (e && e.pointerId != null && sizeList.releasePointerCapture && sizeList.hasPointerCapture(e.pointerId)) {
          try { sizeList.releasePointerCapture(e.pointerId); } catch (err) {}
        }
        card.classList.remove('is-dragging-open');
        setTimeout(function () {
          sizeList.classList.remove('is-dragging');
        }, 0);
      }

      sizeList.addEventListener('pointerdown', function (e) {
        dragging = true;
        moved = 0;
        startX = e.clientX;
        startScroll = sizeList.scrollLeft;
      });

      sizeList.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 3) {
          moved = Math.abs(dx);
          sizeList.classList.add('is-dragging');
          card.classList.add('is-dragging-open');
          if (e.pointerType === 'mouse') {
            e.preventDefault();
            // La captura se pide aquí, no en pointerdown: si se pide antes, el
            // navegador redirige el click al contenedor y los botones dejan de
            // poder pulsarse.
            if (sizeList.setPointerCapture && !sizeList.hasPointerCapture(e.pointerId)) {
              try { sizeList.setPointerCapture(e.pointerId); } catch (err) {}
            }
            sizeList.scrollLeft = startScroll - dx;
          }
        }
      });

      ['pointerup', 'pointercancel'].forEach(function (evt) {
        sizeList.addEventListener(evt, endDrag);
      });
      window.addEventListener('pointerup', endDrag);

      sizeList.addEventListener('scroll', updateOverflow, { passive: true });
      unfOnResize(updateOverflow);
      if (window.ResizeObserver) {
        new ResizeObserver(updateOverflow).observe(sizeList);
      }
      updateOverflow();

      sizeList.addEventListener('click', function (e) {
        if (moved > 5) {
          e.preventDefault();
          e.stopPropagation();
          moved = 0;
        }
      }, true);

      sizeList.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });
    }

    if (mobileToggle) {
      mobileToggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var willOpen = !card.classList.contains('is-popup-open');
        document.querySelectorAll('.ctl-card.is-popup-open').forEach(function (other) {
          if (other !== card) other.classList.remove('is-popup-open');
        });
        card.classList.toggle('is-popup-open', willOpen);
        mobileToggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    } else if (infoEl && sizePopupEl) {
      // Sin botón +, el comportamiento táctil anterior sigue disponible.
      infoEl.addEventListener('click', function (e) {
        if (window.matchMedia('(hover: hover)').matches) return;
        if (e.target.closest('.ctl-name')) return;
        if (e.target.closest('.ctl-size-popup')) return;
        card.classList.add('is-popup-open');
      });
    }

    if (sizePopupEl) {
      sizePopupEl.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (!selectedVariantId || addBtn.disabled) return;

        addBtn.disabled = true;

        ctlAddToCart(selectedVariantId)
          .then(function () {
            addBtn.classList.add('is-added');

            setTimeout(function () {
              addBtn.classList.remove('is-added');
              card.classList.remove('is-popup-open');
              updateAddState();
            }, 1500);
          })
          .catch(function () {
            updateAddState();
          });
      });
    }
  });

  // ══════════════════════════════════════════════════════════════
  // CÓMO SE CIERRA EL PANEL DE TALLAS AL TOCAR FUERA (móvil).
  //
  // Antes: el listener quitaba la clase pero NO frenaba el tap, así que
  // el mismo toque que cerraba el panel seguía su camino y abría el
  // producto que hubiera debajo. Yendo rápido, se entraba a productos
  // sin querer.
  //
  // Ahora, en celular, el PRIMER toque fuera solo cierra: se traga y no
  // activa nada. El segundo ya funciona normal.
  //
  // La zona del precio va aparte: ahí están los círculos de color, que
  // en celular son diminutos y se fallan constantemente. Tocarla no
  // cierra; hacen falta TRES toques seguidos. Acertarle a un círculo
  // reinicia la cuenta, y dejar pasar más de un segundo y medio también.
  // ══════════════════════════════════════════════════════════════
  if (!document.body.dataset.ctlOutsideClickInit) {
    document.body.dataset.ctlOutsideClickInit = 'true';

    var CTL_PRICE_TAPS_TO_CLOSE = 3;
    var CTL_PRICE_TAP_WINDOW = 1500;
    var ctlPriceTaps = 0;
    var ctlPriceTapAt = 0;

    function ctlIsMobile() {
      return window.matchMedia('(max-width: 749px)').matches || window.matchMedia('(hover: none)').matches;
    }

    function ctlCloseCard(c) {
      c.classList.remove('is-popup-open');
      var t = c.querySelector('.ctl-mobile-toggle');
      if (t) t.setAttribute('aria-expanded', 'false');
    }

    document.addEventListener(
      'click',
      function (e) {
        var open = document.querySelector('.ctl-card.is-popup-open');
        if (!open) {
          ctlPriceTaps = 0;
          return;
        }

        // El panel de tallas y el botón + siguen funcionando igual. Todo
        // lo demás —incluida la foto de esta misma tarjeta— cuenta como
        // "fuera": el primer toque solo cierra.
        if (e.target.closest && e.target.closest('.ctl-size-popup, .ctl-mobile-toggle')) return;

        if (!ctlIsMobile()) {
          if (!open.contains(e.target)) ctlCloseCard(open);
          return;
        }

        var price = open.querySelector('.ctl-price');
        var swatches = open.querySelector('.ctl-swatches');
        var inPriceZone =
          (price && price.contains(e.target)) || (swatches && swatches.contains(e.target));

        if (inPriceZone) {
          if (e.target.closest('.ctl-swatch')) {
            ctlPriceTaps = 0;
            return;
          }

          e.preventDefault();
          e.stopPropagation();

          var now = Date.now();
          ctlPriceTaps = now - ctlPriceTapAt > CTL_PRICE_TAP_WINDOW ? 1 : ctlPriceTaps + 1;
          ctlPriceTapAt = now;

          if (ctlPriceTaps >= CTL_PRICE_TAPS_TO_CLOSE) {
            ctlPriceTaps = 0;
            ctlCloseCard(open);
          }
          return;
        }

        ctlPriceTaps = 0;
        e.preventDefault();
        e.stopPropagation();
        document.querySelectorAll('.ctl-card.is-popup-open').forEach(ctlCloseCard);
      },
      true
    );
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product_card_glass"] && !Shopify.designMode) return;
  try {
    (function () {
  // Registro global de paneles "portados" a document.body, para el cierre
  // por clic afuera y el reposicionamiento en scroll/resize.
  window.__pcardPanels = window.__pcardPanels || [];

  document.querySelectorAll('.pcard').forEach(function (card) {
    if (card.dataset.pcardInit === 'true') return;
    card.dataset.pcardInit = 'true';

    var img = card.querySelector('.pcard-image');
    var mediaEl = card.querySelector('.pcard-media');
    var template = card.querySelector('.pcard-sizes-template');
    var variantsDataEl = card.querySelector('.pcard-variants-data');
    var colorPos = card.getAttribute('data-color-position');
    var sizePos = card.getAttribute('data-size-position');
    var variants = [];

    try {
      variants = variantsDataEl ? JSON.parse(variantsDataEl.textContent) : [];
    } catch (e) {
      variants = [];
    }

    var sizesEl = null;
    var addBtn = null;

    // Mover el panel de tallas fuera del <template> y de la tarjeta,
    // directo a document.body, para que quede libre de cualquier
    // overflow/border-radius/transform de un contenedor padre.
    if (template && template.content) {
      sizesEl = template.content.firstElementChild.cloneNode(true);

      // El panel deja de ser descendiente de la tarjeta, así que ya no
      // hereda las variables CSS definidas en su style inline (blur, tinte,
      // radio). Se copian aquí directamente para que sigan funcionando.
      var cardStyles = getComputedStyle(card);
      ['--pcard-panel-radius', '--pcard-blur', '--pcard-glass-tint'].forEach(function (varName) {
        var val = cardStyles.getPropertyValue(varName);
        if (val) sizesEl.style.setProperty(varName, val.trim());
      });

      document.body.appendChild(sizesEl);
      addBtn = sizesEl.querySelector('.pcard-add-btn');
    }

    var selectedColor = null;
    var selectedSize = null;
    var selectedVariantId = null;
    var closeTimer = null;

    function optionValue(variant, position) {
      if (position == 1) return variant.option1;
      if (position == 2) return variant.option2;
      if (position == 3) return variant.option3;
      return null;
    }

    function positionPanel() {
      if (!sizesEl || !mediaEl) return;
      var rect = mediaEl.getBoundingClientRect();
      sizesEl.style.left = rect.left + 'px';
      sizesEl.style.width = rect.width + 'px';
      sizesEl.style.top = (rect.bottom - sizesEl.offsetHeight) + 'px';
    }

    function openPanel() {
      if (!sizesEl) return;
      clearTimeout(closeTimer);
      positionPanel();
      sizesEl.classList.add('is-open');
    }

    function closePanelNow() {
      if (!sizesEl) return;
      sizesEl.classList.remove('is-open');
      card.classList.remove('is-popup-open');
    }

    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closePanelNow, 150);
    }

    // Atenúa las tallas que no existen para el color elegido
    function refreshSizeAvailability() {
      if (!sizesEl) return;

      if (!selectedColor) {
        sizesEl.querySelectorAll('.pcard-size-btn').forEach(function (b) {
          b.disabled = false;
        });
        return;
      }

      sizesEl.querySelectorAll('.pcard-size-btn').forEach(function (b) {
        var size = b.getAttribute('data-size');
        var match = variants.find(function (v) {
          return (
            optionValue(v, colorPos) === selectedColor &&
            optionValue(v, sizePos) === size
          );
        });
        b.disabled = !(match && match.available);

        if (b.disabled && b.classList.contains('is-selected')) {
          b.classList.remove('is-selected');
          selectedSize = null;
        }
      });
    }

    function updateAddState() {
      selectedVariantId = null;

      if (selectedColor && selectedSize) {
        var match = variants.find(function (v) {
          return (
            optionValue(v, colorPos) === selectedColor &&
            optionValue(v, sizePos) === selectedSize
          );
        });
        if (match && match.available) {
          selectedVariantId = match.id;
        }
      }

      if (addBtn) {
        addBtn.disabled = !selectedVariantId;
      }
    }

    card.querySelectorAll('.pcard-swatch').forEach(function (sw) {
      sw.addEventListener('click', function () {
        card.querySelectorAll('.pcard-swatch').forEach(function (s) {
          s.classList.remove('is-active');
        });
        sw.classList.add('is-active');
        selectedColor = sw.getAttribute('data-color');

        var newSrc = sw.getAttribute('data-image');
        if (newSrc && img) {
          img.removeAttribute('srcset');
          img.src = newSrc;
        }

        refreshSizeAvailability();
        updateAddState();
      });
    });

    if (sizesEl) {
      sizesEl.querySelectorAll('.pcard-size-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          sizesEl.querySelectorAll('.pcard-size-btn').forEach(function (b) {
            b.classList.remove('is-selected');
          });
          btn.classList.add('is-selected');
          selectedSize = btn.getAttribute('data-size');
          updateAddState();
        });
      });

      // Escritorio: hover sobre la imagen O sobre el panel lo mantiene abierto
      if (mediaEl) {
        mediaEl.addEventListener('mouseenter', function () {
          if (!window.matchMedia('(hover: hover)').matches) return;
          openPanel();
        });
        mediaEl.addEventListener('mouseleave', function () {
          if (!window.matchMedia('(hover: hover)').matches) return;
          scheduleClose();
        });
      }
      sizesEl.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
      });
      sizesEl.addEventListener('mouseleave', function () {
        if (!window.matchMedia('(hover: hover)').matches) return;
        scheduleClose();
      });
      sizesEl.addEventListener('focusin', function () {
        clearTimeout(closeTimer);
        openPanel();
      });

      // Táctil: un tap sobre la imagen abre el panel en vez de navegar
      if (mediaEl) {
        mediaEl.addEventListener('click', function (e) {
          if (window.matchMedia('(hover: hover)').matches) return;
          if (sizesEl.classList.contains('is-open')) return;
          e.preventDefault();
          card.classList.add('is-popup-open');
          openPanel();
        });
      }

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          if (!selectedVariantId || addBtn.disabled) return;

          addBtn.disabled = true;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: selectedVariantId, quantity: 1 })
          })
            .then(function (res) {
              if (!res.ok) throw new Error('No se pudo añadir al carrito');
              return res.json();
            })
            .then(function () {
              addBtn.classList.add('is-added');

              // Traer el HTML actual (el carrito ya está actualizado en el servidor)
              return fetch(window.location.href, {
                headers: { 'X-Requested-With': 'XMLHttpRequest' }
              })
                .then(function (res) { return res.text(); })
                .then(function (html) {
                  var parser = new DOMParser();
                  var freshDoc = parser.parseFromString(html, 'text/html');

                  var drawerSelectors = [
                    'cart-drawer',
                    '#cart-drawer',
                    '.cart-drawer',
                    '#CartDrawer',
                    '.CartDrawer',
                    '[id*="cart-drawer" i]',
                    '[class*="cart-drawer" i]',
                    '[id*="cartdrawer" i]',
                    '[class*="cartdrawer" i]'
                  ];

                  for (var i = 0; i < drawerSelectors.length; i++) {
                    var currentEl = document.querySelector(drawerSelectors[i]);
                    var freshEl = freshDoc.querySelector(drawerSelectors[i]);
                    if (currentEl && freshEl) {
                      currentEl.innerHTML = freshEl.innerHTML;
                      break;
                    }
                  }

                  var countEls = document.querySelectorAll(
                    '[data-cart-count], .cart-count-bubble, #CartCount, #cart-icon-bubble'
                  );
                  countEls.forEach(function (el) {
                    var freshCountEl = null;
                    if (el.id) freshCountEl = freshDoc.querySelector('#' + el.id);
                    if (!freshCountEl && el.className) {
                      freshCountEl = freshDoc.querySelector('.' + Array.from(el.classList).join('.'));
                    }
                    if (freshCountEl) el.innerHTML = freshCountEl.innerHTML;
                  });

                  document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                });
            })
            .then(function () {
              var cartDrawer = document.querySelector('cart-drawer, #cart-drawer, .cart-drawer');
              if (cartDrawer && typeof cartDrawer.open === 'function') {
                cartDrawer.open();
              } else {
                var cartIconTrigger = document.querySelector(
                  '[data-cart-drawer-toggle], a[href="/cart"].header__cart-icon'
                );
                if (cartIconTrigger) cartIconTrigger.click();
              }

              setTimeout(function () {
                addBtn.classList.remove('is-added');
                closePanelNow();
                updateAddState();
              }, 1500);
            })
            .catch(function () {
              updateAddState();
            });
        });
      }
    }

    // Si solo hay un color, lo preselecciona para que las tallas funcionen ya
    var swatches = card.querySelectorAll('.pcard-swatch');
    if (swatches.length === 1) {
      selectedColor = swatches[0].getAttribute('data-color');
      swatches[0].classList.add('is-active');
      refreshSizeAvailability();
    } else if (swatches.length === 0) {
      // Producto sin opción de color: emparejar solo por talla
      colorPos = 0;
      selectedColor = null;
    }

    if (sizesEl) {
      window.__pcardPanels.push({ card: card, mediaEl: mediaEl, sizesEl: sizesEl, reposition: positionPanel });
    }
  });

  // Cierra los paneles abiertos al hacer clic fuera de la tarjeta Y fuera
  // del panel (que ahora vive en document.body, no dentro de la tarjeta).
  if (!document.body.dataset.pcardOutsideClickInit) {
    document.body.dataset.pcardOutsideClickInit = 'true';

    document.addEventListener('click', function (e) {
      window.__pcardPanels.forEach(function (p) {
        if (!p.sizesEl.classList.contains('is-open')) return;
        if (p.card.contains(e.target) || p.sizesEl.contains(e.target)) return;
        p.sizesEl.classList.remove('is-open');
        p.card.classList.remove('is-popup-open');
      });
    });

    // Reposiciona los paneles abiertos si la página hace scroll o cambia de tamaño
    var repositionOpenPanels = function () {
      window.__pcardPanels.forEach(function (p) {
        if (p.sizesEl.classList.contains('is-open')) p.reposition();
      });
    };
    window.addEventListener('scroll', repositionOpenPanels, { passive: true, capture: true });
    window.addEventListener('resize', repositionOpenPanels, { passive: true });
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["quick-shop-hover"] && !Shopify.designMode) return;
  try {
    (function () {
  document.querySelectorAll('.qsh-wrapper').forEach(function (wrapper) {
    if (wrapper.dataset.qshInit === 'true') return;
    wrapper.dataset.qshInit = 'true';

    var card = wrapper.closest('.resource-list__item') || wrapper.parentElement;
    var img = card ? card.querySelector('img') : null;
    var addBtn = wrapper.querySelector('.qsh-add-btn');
    var variantsDataEl = wrapper.querySelector('.qsh-variants-data');
    var colorPos = wrapper.getAttribute('data-color-position');
    var sizePos = wrapper.getAttribute('data-size-position');
    var variants = [];

    try {
      variants = variantsDataEl ? JSON.parse(variantsDataEl.textContent) : [];
    } catch (e) {
      variants = [];
    }

    var selectedColor = null;
    var selectedSize = null;
    var selectedVariantId = null;

    function optionValue(variant, position) {
      if (position == 1) return variant.option1;
      if (position == 2) return variant.option2;
      if (position == 3) return variant.option3;
      return null;
    }

    function updateAddState() {
      selectedVariantId = null;

      if (selectedColor && selectedSize) {
        var match = variants.find(function (v) {
          return (
            optionValue(v, colorPos) === selectedColor &&
            optionValue(v, sizePos) === selectedSize
          );
        });
        if (match && match.available) {
          selectedVariantId = match.id;
        }
      }

      if (addBtn) {
        addBtn.disabled = !selectedVariantId;
      }
    }

    wrapper.querySelectorAll('.qsh-swatch').forEach(function (sw) {
      sw.addEventListener('click', function () {
        wrapper.querySelectorAll('.qsh-swatch').forEach(function (s) {
          s.classList.remove('is-active');
        });
        sw.classList.add('is-active');
        selectedColor = sw.getAttribute('data-color');
        var newSrc = sw.getAttribute('data-image');
        if (newSrc && img) img.src = newSrc;
        updateAddState();
      });
    });

    wrapper.querySelectorAll('.qsh-size-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        wrapper.querySelectorAll('.qsh-size-btn').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');
        selectedSize = btn.getAttribute('data-size');
        updateAddState();
      });
    });

    // Táctil: en dispositivos sin hover, un tap dentro del wrapper (p. ej.
    // sobre un swatch) revela el panel de tallas glass, igual que el hover
    // en escritorio. La tarjeta sigue siendo navegable desde su propio link.
    wrapper.addEventListener('click', function (e) {
      if (window.matchMedia('(hover: hover)').matches) return;
      wrapper.classList.add('is-popup-open');
    });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (!selectedVariantId || addBtn.disabled) return;

        addBtn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: selectedVariantId, quantity: 1 })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('No se pudo añadir al carrito');
            return res.json();
          })
          .then(function () {
            addBtn.classList.add('is-added');
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

            // Intenta abrir el drawer del carrito si tu tema usa el componente <cart-drawer>
            var cartDrawer = document.querySelector('cart-drawer, #cart-drawer, .cart-drawer');
            if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            }

            setTimeout(function () {
              addBtn.classList.remove('is-added');
              wrapper.classList.remove('is-popup-open');
              updateAddState();
            }, 1500);
          })
          .catch(function () {
            updateAddState();
          });
      });
    }
  });

  // Cierra cualquier panel de tallas abierto por tap si el usuario toca fuera
  // de la tarjeta. Un solo listener global, protegido para no duplicarse.
  if (!document.body.dataset.qshOutsideClickInit) {
    document.body.dataset.qshOutsideClickInit = 'true';
    document.addEventListener('click', function (e) {
      document.querySelectorAll('.qsh-wrapper.is-popup-open').forEach(function (openWrapper) {
        if (!openWrapper.contains(e.target)) {
          openWrapper.classList.remove('is-popup-open');
        }
      });
    });
  }
})();
  } catch(e) { console.error(e); }
})();

})();
